/**
 * URLs de PinPad Web v2.6.0
 * 
 * Configuración de ambientes para el iframe de PinPad Web
 * 
 * @module pinpad-v2/urls
 */

export const PINPAD_URLS = {
  QA: 'https://fcqa.mitec.com.mx/pinpadWeb/ppw_2.6.0/index.html',
  PROD: 'https://m.mit.com.mx/pinpadWeb/ppw_2.6.0/index.html'
}

/**
 * Obtiene la URL del iframe según el ambiente
 * @param {string} environment - 'QA' o 'PROD'
 * @returns {string} URL del iframe
 */
export const getPinpadUrl = (environment = 'QA') => {
  const url = PINPAD_URLS[environment]
  
  if (!url) {
    console.warn(`Environment "${environment}" not found, using QA`)
    return PINPAD_URLS.QA
  }
  
  return url
}

/**
 * Valida si el ambiente es válido
 * @param {string} environment
 * @returns {boolean}
 */
export const isValidEnvironment = (environment) => {
  return environment === 'QA' || environment === 'PROD'
}
